/** Compare setup DTOs by content, not transport/object insertion order.
 * Array order and every serialized value remain significant; this is not a
 * projection that drops metadata or weakens protection for unsaved edits. */
export function setupSnapshotKey(value: unknown): string | undefined {
  return JSON.stringify(value, (_key, item) => {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return item;
    return Object.fromEntries(
      Object.keys(item)
        .sort()
        .map((key) => [key, item[key]]),
    );
  });
}
